import {format} from "fecha";

const dateLongFormat = 'ddd MMM Do'
const dateTimeLongFormat = 'ddd MMM Do, h:mma'

const getDateTimeStringWithoutOffset = (date) => {
    if (date.includes('+')) {
        return date.slice(0, Math.max(0, date.indexOf('+')));
    }
    return date.slice(0, Math.max(0, date.lastIndexOf('-')));

}

const formatStartWithoutTimezone = (dt) => format(new Date(getDateTimeStringWithoutOffset(dt)), dateTimeLongFormat)

const formatStartDateOnlyWithoutTimezone = (dt) => format(new Date(getDateTimeStringWithoutOffset(dt)), dateLongFormat)

const formatDateWithoutTimezone = (startDate, endDate) => {
    startDate = getDateTimeStringWithoutOffset(startDate)
    endDate = getDateTimeStringWithoutOffset(endDate)
    // Note to Aman: startDate & endDate needs to be localized
    const sameDayStartDate = format(new Date(startDate), 'dddd, MMM Do YYYY ');

    const formattedStartDate = format(new Date(startDate), dateTimeLongFormat);
    const formattedEndDate = format(new Date(endDate), dateTimeLongFormat);

    const formattedStartHour = format(new Date(startDate), 'h:mma');
    const formattedEndHour = format(new Date(endDate), 'h:mma');

    const formattedStartDay = format(new Date(startDate), 'Do');
    const formattedEndDay = format(new Date(endDate), 'Do');
    const endsOnSameDay = formattedStartDay === formattedEndDay

    return (
        endsOnSameDay ?
            `${sameDayStartDate}
             ${formattedStartHour} - ${formattedEndHour}`
            :
            `${formattedStartDate}
            ${formattedEndDate}
            `
    )
}

export {formatDateWithoutTimezone, formatStartDateOnlyWithoutTimezone, formatStartWithoutTimezone}